<template>
    <div class="container">
        <DataAtual/>
        <b-breadcrumb :items="this.$route.meta.breadcrumb"></b-breadcrumb>
        <b-card
            class="p-1 bg-white rounded"
            footer-bg-variant="transparent">
           <alert
                :variant="alert.variant"
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert>
            <b-row>
                <b-col >
                    <b-form-group label="Busca por palavra-chave"  label-class="font-weight-bold">
                        <b-input-group >
                            <b-form-input
                                v-model="palavraChave"
                                placeholder="Digite aqui o termo que deseja pesquisar"
                                aria-describedby="feedback_busca_palavra_chave"
                                @keydown.native="keydownBuscaPalavraChave"
                                @keypress.native="keypressBuscaPalavraChave"
                                :state="palavraChaveState">
                            </b-form-input>

                            <b-input-group-append>
                                <b-button
                                    v-if="!buscaAvancada"
                                    @click="reloadPage()"
                                    variant="primary"
                                    v-b-hover="btnBuscarHover"
                                    class="btn-buscar fa fa-search ">
                                    <a class="label">{{this.labelBtnBuscar}}</a>
                                </b-button>
                                <b-button
                                    @click="buscaAvancada = !buscaAvancada"
                                    variant="outline-primary"
                                    v-b-hover="btnBuscaAvancadaHover"
                                    class="btn-busca-avancada fa fa-search-plus ">
                                    <a class="label">{{labelBtnBuscaAvancada}}</a>
                                </b-button>
                            </b-input-group-append>

                            <b-form-invalid-feedback id="feedback_busca_palavra_chave">
                                Informe o termo para pesquisa
                            </b-form-invalid-feedback>
                        </b-input-group>
                        <b-row>
                            <b-col class="card-busca-avancada" >
                                <BuscaAvancada
                                    v-show="buscaAvancada"
                                    :params="paramsBuscaAvancada"
                                    @pesquisar="reloadPage()"
                                    @fechar="buscaAvancada = false">
                                </BuscaAvancada>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-slot:footer >
                <b-row >
                    <b-col class="text-left">
                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click.prevent="$router.push({ name: 'home' })"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i> Voltar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-card>

        <b-card class="mt-3 mb-5 bg-white rounded" v-if="tabela.totalRows == 0" >
            <div class="mb-2 ml-1 text-center">
                <p class="msg-documento-nao-encontrado">Nenhum documento encontrado para "<strong>{{termoPesquisado}}</strong>"</p>
            </div>
        </b-card>
        <b-card class="mt-3 mb-3 bg-white rounded" v-if="tabela.totalRows > 0" >
            <div class="msg-numero-documento-encontrado" slot="header">
                <strong>{{tabela.totalRows}}</strong> resultado(s) encontrado(s) para <strong>"{{termoPesquisado}}"</strong>
            </div>

            <div>
                <b-table
                    :fields="tabela.fields"
                    :items="tabela.items"
                    borderless
                    responsive
                    thead-class="hidden-header"
                    >
                    <template v-slot:cell(result)="data" >
                        <b-card
                            border-variant="white"
                            :title="data.item.titulo"
                            title-tag="h5"
                            sub-title-text-variant="primary"
                            :sub-title="data.item.subtitulo"
                            footer-bg-variant="light"
                            footer-tag="footer">

                            <p class="card-intertitulo">{{data.item.intertitulo}}</p>

                            <b-card-text class="text-secondary">
                                <span v-html="data.item.resultado"></span>
                            </b-card-text>

                            <template v-slot:footer>
                                <b-button
                                    v-if="exibirBtnDownload(data.item)"
                                    size="sm"
                                    variant="outline-secondary"
                                    @click="download(data.item)">
                                    <i class="fa fa-download pr-1"></i> Download
                                </b-button>
                                <router-link
                                    v-if="exibirBtnVisualizar(data.item)"
                                    :to="obterParamsRouterLinkVisualizar(data.item)"
                                >
                                    <b-button
                                        class="mx-2"
                                        size="sm"
                                        variant="outline-secondary"
                                        @click="clickVisualizar(data.item)">
                                        <i class="fa fa-eye pr-1"></i> Visualizar
                                    </b-button>
                                </router-link>
                            </template>
                        </b-card>
                    </template>
                </b-table>
            </div>

            <template v-slot:footer>
                <b-row>
                    <b-col class="my-2 mx-5">
                        <b-row>
                            <p class="label-numero-documento">Listando de <strong>{{registroInicialPagina}}</strong> a <strong>{{registroFinalPagina}}</strong></p>
                        </b-row>
                    </b-col>
                    <b-col md="3" sm="12" >
                        <b-form-group
                            label-cols="8"
                            label="Itens por página:"
                            label-align="right"
                            label-size="sm"
                            label-class="mt-1 text-secondary" >
                            <b-form-select
                                v-model="tabela.perPage"
                                size="sm"
                                :options="tabela.pageOptions"
                                @change="mudarItensPorPagina()"
                                >
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="auto"  >
                        <b-pagination
                            v-if="tabela.totalRows > tabela.perPage"
                            align="right"
                            :total-rows="tabela.totalRows"
                            :per-page="tabela.perPage"
                            :value="tabela.currentPage"
                            @change="mudarPagina"
                            class="mt-2"
                            size="sm">
                        </b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-card>
    </div>
</template>

<script>
/* eslint-disable */

import Alert from '../../models/Alert'
import DataAtual from '../../components/DataAtual';
import BuscaAvancada from '../../components/BuscaAvancada';
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";

export default {
    components: {
        BuscaAvancada,
        DataAtual
    },

    mixins: [validationMixin],

    data(){
        return {
            termoPesquisado:'',
            palavraChave: '',
            palavraChaveState: null,
            paramsBuscaAvancada: {
                tipoPesquisa: this.$constantes.pesquisa.tipoPesquisa.QUALQUER_RESULTADO,
                formaPesquisa: this.$constantes.pesquisa.formaPesquisa.EDICOES,
                ondePesquisar: this.$constantes.pesquisa.ondePesquisar.CONTEUDO,
                dataInicio: null,
                dataFim: null,
                numeroEdicao: null,
                categoriaAtoId: null,
                orgaoId: null,
                orgao:null,
            },
            buscaAvancada: false,
            tabela:{
                currentPage: 1,
                items: [],
                fields: [
                    {
                        key: 'result',
                        label: '',
                    },
                ],
                perPage: 10,
                totalRows: 0,
                pageOptions: [10, 25, 50],
            },
            alert: new Alert(),
            labelBtnBuscar: '',
            labelBtnBuscaAvancada: '',
        }
    },

    computed:{
        registroInicialPagina(){
            return ((this.tabela.currentPage - 1) * this.tabela.perPage) + 1;
        },

        registroFinalPagina(){
            let regFinal = this.tabela.currentPage * this.tabela.perPage;
            if(regFinal > this.tabela.totalRows){
                regFinal = this.tabela.totalRows;
            }
            return regFinal;
        }
    },

    validations: {
        palavraChave: {
            requiredIf: requiredIf(function () {
                return !this.buscaAvancada;
            })
        },
    },

    methods: {

        alertDismissed(){
            this.alert = new Alert();
        },

        btnBuscarHover(hovered){
            this.labelBtnBuscar = '';
            if(hovered){
                this.labelBtnBuscar = "Buscar";
            }
        },

        exibirBtnDownload(item){
            return item._index === this.$constantes.indices.EDICAO || item._index === this.$constantes.indices.ANEXOATO;
        },

        exibirBtnVisualizar(item){
            if(item._index === this.$constantes.indices.EDICAO &&
               item._source.documento_jornal.size > this.$constantes.documentos.TAMANHO_LIMITE_PARA_VISUALIZACAO){
                return false;
            }

            if(item._index === this.$constantes.indices.ANEXOATO &&
               ((item._source.documento_anexo_ato.extensao != 'pdf' && item._source.documento_anexo_ato.extensao != 'txt') ||
                 item._source.documento_anexo_ato.size > this.$constantes.documentos.TAMANHO_LIMITE_PARA_VISUALIZACAO)){
                return false;
            }

            return true;
        },

        btnBuscaAvancadaHover(hovered){
            this.labelBtnBuscaAvancada = '';
            if(hovered || this.buscaAvancada){
                this.labelBtnBuscaAvancada = "Busca Avançada";
            }
        },

        download(item) {
            let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${item.hash}/download`;
            const prefix = this.obterPrefix(item);
            if(prefix){
                url += `?prefix=${prefix}`; 
            }
            window.location.href = url;
        },

        clickVisualizar(item) {
            if(this.$helper.isMobile() &&  (item._index === this.$constantes.indices.EDICAO || item._index === this.$constantes.indices.ANEXOATO)) {
                let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${item.hash}`;
                const prefix = this.obterPrefix(item);
                if(prefix){
                    url += `?prefix=${prefix}`;
                }
                window.open(url);
            }
        },

        obterParamsRouterLinkVisualizar(item){
            let to = null;

            switch (item._index) {
                case this.$constantes.indices.EDICAO:
                    to = { name: 'visualizacaoEdicao', params: {id: item._source.edicao.id } };
                    break;
                case this.$constantes.indices.ATO:
                    to =  { name: 'visualizacaoAto', params: {id: item._source.ato.id } };
                    break;
                case this.$constantes.indices.ANEXOATO:
                    to = { name: 'visualizacaoAnexoAto', params: {id: item._source.anexo_ato.id } };
                    break;
            }

            return (this.$helper.isMobile()  &&  (item._index === this.$constantes.indices.EDICAO || item._index === this.$constantes.indices.ANEXOATO)) ? '' : to;
        },

        
        obterPrefix(item){
            let prefix = null;

            switch (item._index) {
                case this.$constantes.indices.EDICAO:
                    prefix = JSON.parse(item._source.documento_jornal.prefix);
                    break;
                case this.$constantes.indices.ANEXOATO:
                    prefix = JSON.parse(item._source.documento_anexo_ato.prefix);
                    break;
            }

            return prefix;
        },

        pesquisaAvancada() {
            if(this.paramsBuscaAvancada.formaPesquisa === this.$constantes.pesquisa.formaPesquisa.ATOS){
                this.pesquisaAto();
            }else if(this.paramsBuscaAvancada.formaPesquisa === this.$constantes.pesquisa.formaPesquisa.EDICOES){
                this.pesquisaEdicao();
            }
            this.buscaAvancada = false;
        },

        reloadPage() {
            if( !this.buscaAvancada && this.palavraChave.trim().length <= 0 ){
                this.palavraChaveState = false;
                return;
            }

            var href=`?palavraChave=${this.palavraChave}&tipoPesquisa=${this.paramsBuscaAvancada.tipoPesquisa}&formaPesquisa=${this.paramsBuscaAvancada.formaPesquisa}&ondePesquisar=${this.paramsBuscaAvancada.ondePesquisar}&dataInicio=${this.paramsBuscaAvancada.dataInicio}&dataFim=${this.paramsBuscaAvancada.dataFim}&numeroEdicao=${!this.paramsBuscaAvancada.numeroEdicao ? '' : this.paramsBuscaAvancada.numeroEdicao}&categoriaAtoId${!this.paramsBuscaAvancada.categoriaAtoId ? '' : '='+this.paramsBuscaAvancada.categoriaAtoId}&orgaoId=${this.paramsBuscaAvancada.orgaoId == undefined ? '' : this.paramsBuscaAvancada.orgaoId}&orgao=${this.paramsBuscaAvancada.orgao == null ? '' : this.paramsBuscaAvancada.orgao}&buscaAvancada=${this.buscaAvancada}`;

            window.location.href = encodeURI(href);

        },

        getHoraDataFim(dataFim){
            let dataAtual =  moment().format('YYYY-MM-DD');
            return dataFim < dataAtual ? '23:59' : this.$helper.getHoraAtual();
        },

        pesquisaAto(){
            let hora = this.getHoraDataFim(this.paramsBuscaAvancada.dataFim);
            let documentosPesquisa = [];
            let localPesquisa = [];

            this.termoPesquisado = this.palavraChave;

            if(this.paramsBuscaAvancada.ondePesquisar == this.$constantes.pesquisa.ondePesquisar.TITULO){
                documentosPesquisa.push(this.$constantes.pesquisa.documentos.ATOS);
                localPesquisa.push(this.$constantes.pesquisa.ondePesquisar.TITULO);

            }else if(this.paramsBuscaAvancada.ondePesquisar == this.$constantes.pesquisa.ondePesquisar.CONTEUDO){
                documentosPesquisa.push(this.$constantes.pesquisa.documentos.ATOS,
                                        this.$constantes.pesquisa.documentos.ANEXOS_ATOS);
                localPesquisa.push(this.$constantes.pesquisa.ondePesquisar.CONTEUDO);

            }else if(this.paramsBuscaAvancada.ondePesquisar == this.$constantes.pesquisa.ondePesquisar.TUDO ){
                documentosPesquisa.push(this.$constantes.pesquisa.documentos.ATOS,
                                        this.$constantes.pesquisa.documentos.ANEXOS_ATOS);
                localPesquisa.push(this.$constantes.pesquisa.ondePesquisar.TITULO);
                localPesquisa.push(this.$constantes.pesquisa.ondePesquisar.CONTEUDO);
            }

            let parametros = {
                termo: this.palavraChave,
                pesquisa_exata: (this.paramsBuscaAvancada.tipoPesquisa === this.$constantes.pesquisa.tipoPesquisa.RESULTADO_EXATO),
                documentos: documentosPesquisa,
                local_pesquisa: localPesquisa,
                data_inicio: this.buscaAvancada == true && this.paramsBuscaAvancada.dataInicio && this.paramsBuscaAvancada.dataInicio != "null" && this.paramsBuscaAvancada.dataInicio != "" ? this.paramsBuscaAvancada.dataInicio+' '+'00:00' : null,
                data_fim: this.buscaAvancada == true && this.paramsBuscaAvancada.dataFim && this.paramsBuscaAvancada.dataFim != "null" && this.paramsBuscaAvancada.dataFim != "" ? this.paramsBuscaAvancada.dataFim+' '+hora : null,
                numero_edicao: this.paramsBuscaAvancada.numeroEdicao == '' ? null : this.paramsBuscaAvancada.numeroEdicao,
                categoria_ato_id:  this.paramsBuscaAvancada.categoriaAtoId,
                orgao_id: this.paramsBuscaAvancada.orgaoId == '' ? null : this.paramsBuscaAvancada.orgaoId,
                paginacao: { pagina: this.tabela.currentPage, itens_por_pagina: this.tabela.perPage}
            }

            this.$api.ato.pesquisar(parametros).then(response => {
                if(response.status == 200 || response.status == 201){
                    this.tabela.items = [];
                    var resultado = response.data.data.hits;

                    resultado.hits.forEach((element) => {
                        let trechosResultado = [];
                        let textoResultado = '';

                        if(element.highlight.hasOwnProperty('ato.titulo_ato')){
                            trechosResultado = trechosResultado.concat(element.highlight['ato.titulo_ato']);
                        }

                        if(element.highlight.hasOwnProperty('attachment.content')){
                            trechosResultado = trechosResultado.concat(element.highlight['attachment.content']);
                        }

                        trechosResultado.forEach((el) => {
                            textoResultado += "..." + el.substr(0,500) + '... ';
                        });

                        let item = {};
                        item.titulo = "Edição "+ element._source.edicao.numero_edicao +
                                    " - "+ this.$helper.getTipoEdicao(element._source.edicao.tipo_edicao) +
                                    " - "+ this.$helper.formatDataBrasil(element._source.edicao.dt_hr_publicacao);
                        item.subtitulo = element._source.categoria_ato.nome_categoria +" - "+ element._source.ato.titulo_ato;
                        item.resultado = textoResultado;

                        if (element._index === this.$constantes.indices.ANEXOATO){
                            item.intertitulo = 'Anexo ' + element._source.documento_anexo_ato.nome_original;
                        }

                        item.hash = element._id;
                        item._index = element._index;
                        item._source = element._source;

                        this.tabela.items.push(item);

                    });

                    this.tabela.totalRows =  resultado.total.value;
                }
            })
            .catch(error => {
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       `Erro ao pesquisar ato. ${error.response.data.errors}`);
            });
        },

        pesquisaEdicao(){
            let hora = this.getHoraDataFim(this.paramsBuscaAvancada.dataFim);
            let documentosPesquisa = [];

            if(this.buscaAvancada){
                if(this.paramsBuscaAvancada.formaPesquisa == this.$constantes.pesquisa.formaPesquisa.EDICOES){
                    documentosPesquisa.push(this.$constantes.pesquisa.documentos.EDICOES);
                }
            }else{
                documentosPesquisa.push(this.$constantes.pesquisa.documentos.EDICOES,
                                        this.$constantes.pesquisa.documentos.ATOS,
                                        this.$constantes.pesquisa.documentos.ANEXOS_ATOS);
            }

            this.termoPesquisado = this.palavraChave;

            let parametros = {
                termo: this.palavraChave,
                pesquisa_exata: this.buscaAvancada ? (this.paramsBuscaAvancada.tipoPesquisa ===  this.$constantes.pesquisa.tipoPesquisa.RESULTADO_EXATO) : false,
                documentos: documentosPesquisa,
                local_pesquisa: this.buscaAvancada ? this.paramsBuscaAvancada.ondePesquisar : this.$constantes.pesquisa.ondePesquisar.CONTEUDO,
                data_inicio: this.buscaAvancada && this.paramsBuscaAvancada.dataInicio && this.paramsBuscaAvancada.dataInicio != "null" && this.paramsBuscaAvancada.dataInicio != "" ? this.paramsBuscaAvancada.dataInicio+' '+'00:00' : null,
                data_fim: this.buscaAvancada && this.paramsBuscaAvancada.dataFim && this.paramsBuscaAvancada.dataFim != "null" && this.paramsBuscaAvancada.dataFim != "" ? this.paramsBuscaAvancada.dataFim+' '+hora : null ,
                numero_edicao: this.buscaAvancada && this.paramsBuscaAvancada.numeroEdicao != ''  ? this.paramsBuscaAvancada.numeroEdicao : null,
                paginacao: { pagina: this.tabela.currentPage, itens_por_pagina: this.tabela.perPage}
            }

            this.$api.edicao.pesquisar(parametros).then(response => {
                if(response.status == 200 || response.status == 201){
                    this.tabela.items = [];
                    var resultado = response.data.data.hits;

                    resultado.hits.forEach((element) => {
                        let trechosResultado = [];
                        let textoResultado = '';

                        if(element.highlight.hasOwnProperty('attachment.content')){
                            trechosResultado = trechosResultado.concat(element.highlight['attachment.content']);
                        }

                        trechosResultado.forEach((el) => {
                            textoResultado += "..." + el.substr(0,500) + '... ';
                        });

                        let item = {};
                        item.titulo = "Edição "+ element._source.edicao.numero_edicao +
                                        " - "+ this.$helper.getTipoEdicao(element._source.edicao.tipo_edicao) +
                                        " - "+ this.$helper.formatDataBrasil(element._source.edicao.dt_hr_publicacao);

                        if (element._index === this.$constantes.indices.ATO ||
                            element._index === this.$constantes.indices.ANEXOATO){
                            item.subtitulo = element._source.categoria_ato.nome_categoria +" - "+ element._source.ato.titulo_ato;
                        }

                        if (element._index === this.$constantes.indices.ANEXOATO){
                            item.intertitulo = 'Anexo ' + element._source.documento_anexo_ato.nome_original;
                        }

                        item.resultado = textoResultado;

                        item.hash = element._id;
                        item._index = element._index;
                        item._source = element._source;

                        this.tabela.items.push(item);

                    });

                    this.tabela.totalRows = resultado.total.value;
                }
            })
            .catch(error => {
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       `Erro ao pesquisar edição. ${error.response.data.errors}`);
            });
        },

        pesquisar(){
            const query = this.$route.query;
            this.palavraChave = query.palavraChave;
            this.termoPesquisado = this.palavraChave;

            if( query.palavraChave ) {
                Object.assign(this.paramsBuscaAvancada, {
                    tipoPesquisa: query.tipoPesquisa,
                    formaPesquisa: query.formaPesquisa,
                    ondePesquisar: query.ondePesquisar,
                    dataInicio: query.dataInicio,
                    dataFim: query.dataFim,
                    numeroEdicao: query.numeroEdicao,
                    categoriaAtoId: query.categoriaAtoId,
                    orgaoId: query.orgaoId,
                    orgao: query.orgao,
                });
            }

            this.buscaAvancada = (query.buscaAvancada === true || (typeof query.buscaAvancada == 'string' && query.buscaAvancada == 'true')) ? true : false;

            if(this.palavraChave != ''){
                if (this.buscaAvancada){
                    this.pesquisaAvancada();
                }else{
                    this.pesquisaEdicao();
                }
            }

            this.$helper.scrollWindowToTop();
        },

        mudarItensPorPagina(){
            this.tabela.currentPage = 1;
            this.pesquisar();
        },

        mudarPagina(pagina) {
            this.tabela.currentPage = pagina;
            this.pesquisar();
        },

        keydownBuscaPalavraChave(event){
            if (event.which === 13) {// 13 = Tecla Enter
                this.reloadPage();
            }
        },

        keypressBuscaPalavraChave(){
            if(this.palavraChave.trim().length > 0) {
                this.palavraChaveState = null;
            }
        },


    },



    mounted(){
        this.pesquisar();
    }

}
</script>
<style scoped>
    .data {
        font-size: 90%;
        text-align: right;
        padding-bottom: 0.25rem;
    }

    .rodape {
        font-size: small;
    }

    .busca-avancada {
        font-size: small;
    }

    .card-busca-avancada {
        padding-top: 0.15em;
        position: absolute;
        z-index: 1051;
    }

    .card-intertitulo{
        margin-top: -0.4%;
        font-size: small;
        color: var(--gray)
    }

    .label-versao {
       font-size: 70%;
    }

    .breadcrumb{
        font-size: 0.9em;
    }

    .msg-documento-nao-encontrado{
        color: grey;
        font-size: 0.9em;
        text-align: center;
    }

    .msg-numero-documento-encontrado{
        font-size: 0.9em;
        text-align: center;
    }

    .label-numero-documento{
        font-size: 0.89em;
        color: #5F6368;
        padding-top: 0.3em;
    }

</style>

